var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"head",on:{"click":_vm.btn}},[_c('div',{staticClass:"headIcon"}),_c('div',{staticClass:"headTitle"},[_vm._v("嗨科普")]),_c('div',{staticClass:"headOpen"},[_vm._v("打开")])])])}
var staticRenderFns = []

export { render, staticRenderFns }